import { Link, useLocation, Outlet, useNavigate } from "react-router-dom";
import API from "../../services/api";
import {
    getCurrentUser,
    isAdmin,
    isManager,
    isUser
} from "../../utils/currentUser";
import {
    FaBuilding,
    FaFileAlt,
    FaChartBar,
    FaCogs,
    FaUser,
    FaMoneyBillWave   // ✅ ADD THIS HERE
} from "react-icons/fa";
import { useEffect, useState } from "react";
import { FaHome, FaPowerOff } from "react-icons/fa";

function Layout() {
    const [collapsed, setCollapsed] = useState(() => {

        const isMobile = window.innerWidth < 768;

        if (isMobile) {
            return true;
        }

        return localStorage.getItem("sidebarCollapsed") === "true";
    });

    const [openMenu, setOpenMenu] = useState(() => {

        const saved =
            localStorage.getItem("crmMenu");

        return saved
            ? JSON.parse(saved)
            : {
                Masters: true,
                Transactions: true,
                Reports: true,
                "System Admin": true
            };

    });
    const [hovered, setHovered] = useState(null);
    const location = useLocation();
    const navigate = useNavigate();

    const user = getCurrentUser();
    const admin = isAdmin();
    const manager = isManager();
    const normalUser = isUser();

    const handleLogout = () => {
        localStorage.removeItem("user");
        navigate("/");
    };

    const isActive = (path) => {
        return location.pathname === path;
    };

    const toggleMenu = (name) => {
        setOpenMenu(prev => ({ ...prev, [name]: !prev[name] }));
    };

    useEffect(() => {
        localStorage.setItem(
            "crmMenu",
            JSON.stringify(openMenu)
        );
    }, [openMenu]);

    // 🌳 TREE MENU STRUCTURE
    const menuTree = [
        admin && {
            name: "Masters",
            children: [
                { name: "Branch Master", path: "/app/branch", icon: <FaBuilding /> },
                { name: "Employee Master", path: "/app/employee", icon: <FaUser /> },
                { name: "Users Master", path: "/app/users", icon: <FaUser /> },
                { name: "Customer Master", path: "/app/customers", icon: <FaUser /> }
            ]
        }, 
        (admin || manager) && {
            name: "Transactions",
            children: [
                { name: "Daily Call Register", path: "/app/daily-call", icon: <FaFileAlt /> },

                // ✅ ADD THIS NEW LINE
                { name: "Daily Service Entry", path: "/app/daily-service", icon: <FaFileAlt /> },

                { name: "Voucher Entry", path: "/app/voucher-entry", icon: <FaMoneyBillWave /> }  // ✅ ADD THIS
                
            ]
        },
        {
            name: "Reports",
            children: [

                { name: "Daily Call Report", path: "/app/daily-call-report", icon: <FaChartBar /> },

                { name: "Daily Service Report", path: "/app/service-report", icon: <FaChartBar /> },

                // ✅ MOVE DOWN
                {
                    name: "Daily Call - Dashboard",
                    path: "/app/dashboard",
                    icon: <FaChartBar />
                },

                {
                    name: "Daily Service - Dashboard",
                    path: "/app/service-dashboard",
                    icon: <FaChartBar />
                },
                {
                    name: "Voucher - Dashboard",
                    path: "/app/voucher-dashboard",
                    icon: <FaChartBar />
                }
            ]
        },
        admin && {
            name: "System Admin",
            children: [
                { name: "Audit Logs", path: "/app/audit", icon: <FaCogs /> },
                { name: "Import Daily Call", path: "/app/import-daily-call", icon: <FaFileAlt /> },
            ]
        }
    ];
    const [environment, setEnvironment] = useState("");

    //useEffect(() => {
    //    fetch("https://localhost:7172/api/system/environment")
    //        .then(res => res.json())
    //        .then(data => {
    //            setEnvironment(data.environment);
    //        });
    //}, []);
    useEffect(() => {

        API.get("/system/environment")

            .then(res => {

                setEnvironment(
                    res.data.environment
                );

            })

            .catch(() => {

                setEnvironment("");

            });

    }, []);

    useEffect(() => {
        /*console.log("PATH:", location.pathname);*/
    }, [location.pathname]);

    return (
        <div style={styles.container}>

            {/* SIDEBAR */}
            <div style={{
                ...styles.sidebar,
                width: collapsed ? "70px" : "230px",
                minWidth: collapsed ? "70px" : "230px"
            }}>

                {/* HEADER */}
                <div style={styles.menuHeader}>
                    <button
                        onClick={() => {

                            const newValue = !collapsed;

                            setCollapsed(newValue);

                            localStorage.setItem(
                                "sidebarCollapsed",
                                newValue
                            );
                        }}
                        style={styles.toggle}
                    >
                        ☰
                    </button>
                    {!collapsed && <span style={{ fontWeight: "bold"}}>
                        CRM 
                    </span>}
                </div>

                {/* 🌳 TREE MENU */}
                <div style={styles.menu}>
                    {menuTree
                        .filter(Boolean)
                        .map((section, index) => (
                        <div key={index}>

                            {/* SECTION */}
                            <p
                                style={styles.sectionClickable}
                                onClick={() => toggleMenu(section.name)}
                            >
                                {section.name} {!collapsed && (openMenu[section.name] ? "▼" : "▶")}
                            </p>

                            {/* CHILDREN */}
                            {openMenu[section.name] && section.children.map((item, i) => (
                                <Link
                                    key={i}
                                    to={item.path}
                                    title={collapsed ? item.name : ""}   // default tooltip
                                    onMouseEnter={() => setHovered(item.path)}
                                    onMouseLeave={() => setHovered(null)}
                                    style={{
                                        ...styles.link,
                                        ...(location.pathname === item.path && styles.active),

                                        justifyContent: collapsed ? "center" : "flex-start",

                                        background:
                                            location.pathname === item.path
                                                ? "#3742fa"
                                                : hovered === item.path
                                                    ? "#2f3542"
                                                    : "transparent",

                                        transform: hovered === item.path ? "translateX(5px)" : "translateX(0)",
                                        transition: "all 0.2s ease",

                                        marginLeft: collapsed ? "0px" : "15px",
                                        position: "relative"   // 🔥 IMPORTANT for tooltip
                                    }}
                                >
                                    {/* ICON */}
                                    <span style={{ display: "flex", alignItems: "center" }}>
                                        {item.icon || <FaFileAlt />}
                                    </span>

                                    {/* TEXT */}
                                    {!collapsed && item.name}

                                    {/* 🔥 CUSTOM TOOLTIP */}
                                    {collapsed && hovered === item.path && (
                                        <div style={styles.tooltip}>
                                            {item.name}
                                        </div>
                                    )}
                                </Link>
                            ))}

                        </div>
                    ))}
                </div>
            </div>

            {/* MAIN AREA */}
            <div style={{ flex: 1, display: "flex", flexDirection: "column" }}>

                <div style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: "10px",
                    position: "relative",
                    borderBottom: "1px solid #f0f0f0"
                }}>

                    {/* LEFT */}
                    <div>
                        <div>
                            Welcome, <b>{user?.username}</b>
                        </div>

                        <div style={{
                            fontSize: "11px",
                            color: "gray",
                            marginTop: "2px"
                        }}>
                            Environment: {environment}
                        </div>
                        <div style={{
                            fontSize: "11px",
                            color: "gray",
                            marginTop: "2px"
                        }}>
                            Branch : {user?.branchName || "-"} | Role : {user?.role}
                        </div>
                    </div>

                    {/* CENTER */}
                    <div style={{
                        position: "absolute",
                        left: "50%",
                        transform: "translateX(-50%)",
                        fontFamily: "Verdana",
                        fontSize: "20px",
                        fontWeight: "bold",
                        color: "#1976d2"
                    }}>
                        CRM Enterprises Pvt Ltd
                    </div>

                    {/* RIGHT */}
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "15px"
                        }}
                    >

                        <FaHome
                            size={22}
                            title="Home"
                            style={{
                                cursor: "pointer",
                                color: "#1976d2"
                            }}
                            onClick={() => navigate("/app/home")}
                        />

                        <FaPowerOff
                            size={22}
                            title="Logout"
                            style={{
                                cursor: "pointer",
                                color: "#e74c3c"
                            }}
                            onClick={handleLogout}
                        />

                    </div>

                </div>

                <div style={styles.content}>
                    <Outlet />
                </div>

            </div>

        </div>
    );
}

const styles = {
    container: {
        display: "flex",
        height: "100vh",
        minWidth: "1200px",
        fontFamily: "Verdana",
        fontSize: "12px"
    },

    sidebar: {
        background: "#1e272e",
        color: "#fff",
        transition: "all 0.3s ease",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
        height: "100vh"
    },

    topbar: {
        height: "50px",
        background: "#ffffff",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "0 15px",
        borderBottom: "1px solid #ccc"
    },

    content: {
        flex: 1,
        minWidth: 0,
        padding: "0px",
        background: "#f1f2f6",
        overflow: "auto"
    },

    menuHeader: {
        padding: "15px",
        borderBottom: "1px solid #2f3542",
        display: "flex",
        alignItems: "center",
        gap: "10px"
    },

    toggle: {
        background: "none",
        border: "none",
        color: "#fff",
        fontSize: "18px",
        cursor: "pointer"
    },

    menu: {
        padding: "10px",
        flex: 1,
        overflowY: "auto",
        overflowX: "hidden"
    },

    sectionClickable: {
        fontSize: "12px",
        color: "#a4b0be",
        marginTop: "10px",
        marginBottom: "2px",
        textTransform: "uppercase",
        letterSpacing: "1px",
        fontWeight: "600",
        cursor: "pointer"
    },

    //link: {
    //    display: "flex",
    //    alignItems: "center",
    //    gap: "10px",
    //    padding: "8px 10px",
    //    color: "#dcdde1",
    //    textDecoration: "none",
    //    borderRadius: "6px",
    //    marginBottom: "5px",
    //    transition: "0.2s"
    //},

    link: {
        display: "flex",
        alignItems: "center",
        gap: "8px",
        padding: "6px 8px",
        color: "#dcdde1",
        textDecoration: "none",
        borderRadius: "4px",
        marginBottom: "2px",
        transition: "all 0.2s ease"
    },

    active: {
        background: "#3742fa",
        color: "#fff"
    },
    
    tooltip: {
        position: "absolute",
        left: "60px",
        background: "#2f3542",
        color: "#fff",
        padding: "4px 8px",
        borderRadius: "4px",
        fontSize: "11px",
        whiteSpace: "nowrap",
        zIndex: 1000,
        boxShadow: "0 2px 6px rgba(0,0,0,0.2)"
    }
};

export default Layout;